import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { history } from '../store'
import { pick } from 'lodash'

import { impersonateBrokerId } from '../person/actions'
import { toastify } from './../components/shared/Toasts'
import ToastMessages from './components/ToastMessages'
import * as brokeragesApi from '../brokerages/api'
import { saveByteArray, base64ToArrayBuffer } from './../utils/utilities'
import {
  SUBMISSION_STATUS,
  CLEAR_AND_CHANGE_SUBMISSION,
  GET_SUBMISSION,
  EDIT_SUBMISSION,
  CREATE_RELATED_SUBMISSION,
  INITIAL_SUBMISSION_STATE,
  SUBMISSION_SUBMIT_FOR_REVIEW,
  CHANGE_SUBMISSION_DIALOG_STATUS,
  SUBMIT_SUBMISSION_QUOTE,
  FETCH_PRE_CLEARED_SUBMISSION,
  SUBMISSION_UPDATE,
  SUBMISSIONS_REFETCH,
  DOWNLOAD_SUBMISSION_QUOTE,
  UNLOCK_BIND,
  LOCK_BIND,
  DOWNLOAD_SUBMISSION_REVISION_QUOTE,
  DOWNLOAD_SUBMISSION_QUOTE_SPECIMEN,
  SUBMISSION_UPDATE_MANUAL_QUOTE_STATUS,
  LOAD_ARGOPI,
  SUBMISSION_UPDATE_WITH_EDGE_NUMBER
} from './../constants/submission'
import * as submissionActions from './actions'
import * as submissionsApi from './api'
import ToastMessagesPdf from './components/ToastMessagesPdf'

const SUBMISSION_FIELDS_DISABLED = {
  primaryInsuredName: { disabled: true },

  primaryInsuredAddress: { disabled: true },
  primaryInsuredAddress2: { disabled: true },
  primaryInsuredCity: { disabled: true },
  primaryInsuredState: { disabled: true },
  primaryInsuredZipcode: { disabled: true },

  projectAddress: { disabled: true },
  projectAddress2: { disabled: true },
  projectCity: { disabled: true },
  projectState: { disabled: true },
  projectZipcode: { disabled: true },
}
const NEW_SUBMISSION_PROPS = [
  'anticipatedFinishDate',
  'anticipatedStartDate',
  'brokerId',
  'clearanceStatus',
  'contactInfo',
  'generalComments',
  'generalContractorAmount',
  'generalContractorName',
  'generalLiabilityCarrier',
  'insuredAddress',
  'otherSubcontractorsPaid',
  'primaryInsuredName',
  'projectAddress',
  'projectAddress2',
  'projectScope',
  'status',
  'totalCost',
  'type',
  'contractNumber',
  'projectType',
  'constructionSite',
  'structuralWork',
  'StructuralWorkPerformedDetail',
  'squareFootage',
  'squareFootagePercent',
  'storiesFinishedProject',
  'specificFloors',
  'specificFloorsDetails',
  'eightFeet',
  'endUseOfBuilding',
  'commonOwnership',
  'workStarted',
  'generalContractorKnown',
  'exteriorDemo',
  'projectRequirements',
  'isVerticalExpansion',
  'isHorizontalExpansion',
  'demolitionDetailsContractor',
  'demolitionDetailsGCOwner',
  'demolitionDetailsCost',
  'demolitionDetailsInterior',
  'demolitionDetailsStories',
  'demolitionDetailsMethod',
  'demolitionDetailsMonths',
  'demolitionDetailsPrecautions',
  'HorizontalExpansionDetail',
  'auditorName',
  'auditorEmail',
  'auditorPhone',
  'projectName'
]

export function* clearAndChangeSubmissionStatus() {
  try {
    yield put(submissionActions.clearSubmission())
    yield put(submissionActions.changeSubmissionNone())
  } catch (err) {
    console.log({ err })
  }
}

export function* getSubmission({ type, payload: { body, user } }) {
  try {
    const data = yield call(submissionsApi.getSubmissionsPost, body)

    if (data === 0 || data === 403) {
      yield put(submissionsApi.userLogout)
    }

    yield put(submissionActions.fetchSubmissions(data))
  } catch (err) {
    console.log({ err })
  }
}
export function* editSubmission({ type, payload: { submission, user } }) {
  const route = `/submission/${submission.id}`
  try {
    yield put(submissionActions.loadUpsell())

    const response = yield call(submissionsApi.getSubmission, user, {
      id: submission.id,
    })
    if (response.status === 200) {
      yield put(
        submissionActions.changeSubmission(response.data, SUBMISSION_FIELDS_DISABLED),
      )
      yield put(submissionActions.changeSubmissionStatus(SUBMISSION_STATUS.EDIT))
      yield put(submissionActions.loadUpsellSuccess())
      history.push(route)
    } else {
      console.error('Error While Accessing Submissions DB.')
    }
  } catch (err) {
    console.log({ err })
    yield put(submissionActions.loadUpsellFailure())
  }
}

export function* createRelatedSubmission({ type, payload: { submission, user } }) {
  const params = {
    id: submission.id,
  }
  const route = '/submission'
  try {
    yield put(submissionActions.loadUpsell())
    const response = yield call(submissionsApi.getSubmission, user, params)
    if (response.status != 200) {
      return
    }
    const newSubmission = pick(Object.assign(response.data), NEW_SUBMISSION_PROPS)
    if (response.data && response.data.AuditorInfo) {
      Object.assign(newSubmission, { ...response.data.AuditorInfo })
    }
    newSubmission.type = newSubmission.type === 'oi' ? 'ocp' : 'oi'
    if (newSubmission.type === 'oi' && response.data.exteriorWorkFourStories !== undefined) {
      newSubmission.exteriorWorkFiveStories = response.data.exteriorWorkFourStories
    }

    if (newSubmission.type === 'ocp' && response.data.exteriorWorkFiveStories !== undefined) {
      newSubmission.exteriorWorkFourStories = response.data.exteriorWorkFiveStories
    }
    newSubmission.relatedEntities = {
      submissions: [
        {
          type: submission.type,
          id: submission.id,
        },
      ],
    }
    yield put(
      submissionActions.submissionCreate({
        Type: newSubmission.type,
        Origin: submission.id,
        ClearanceStatus: newSubmission.clearanceStatus,
      }),
    )
    yield put(submissionActions.clearSubmission())

    yield put(
      submissionActions.changeSubmission(newSubmission, SUBMISSION_FIELDS_DISABLED),
    )
    yield put(submissionActions.changeSubmissionStatus(SUBMISSION_STATUS.EDIT))
    yield put(submissionActions.loadUpsellSuccess())
    history.push(route)
  } catch (err) {
    console.log({ err })
    yield put(submissionActions.loadUpsellFailure())
  }
}

export function* changeSubmissionDialogStatus({ type, value }) {
  try {
    yield put(submissionActions.setSubmissionDialogStatus(value))
  } catch (err) {
    console.log({ err })
  }
}

export function* submissionSubmitForReview({
  type,
  payload: { submission, dialogStatus },
}) {
  try {
    yield put(submissionActions.setSubmissionDialogStatus(dialogStatus))
    yield put(submissionActions.changeSubmission(submission))
  } catch (err) {
    console.log({ err })
  }
}

export function* setInitialSubmissionState() {
  try {
    yield put(submissionActions.setSubmissionAndDialogStatus())
    yield put(submissionActions.changeSubmissionStatus(SUBMISSION_STATUS.CREATING))
  } catch (err) {
    console.log({ err })
  }
}

export function* submitSubmissionQuote({ type, value: { submission, dialogStatus } }) {
  try {
    yield put(submissionActions.changeSubmission(submission))
    yield put(submissionActions.setSubmissionDialogStatus(dialogStatus))
    history.push('/quote')
  } catch (err) {
    console.log({ err })
  }
}
export function* createPreClearedSubmission({ type, value: { submission } }) {
  const route = '/submission'
  try {
    const { edgeSubmissionId, product, agent_code } = submission
    const brokerages = yield call(brokeragesApi.fetchAll)
    const brokerage = brokerages.filter(({ agencyCode }) => agencyCode == agent_code)
    yield put(impersonateBrokerId(brokerage[0].brokerId))
    const newSubmission = pick(
      {
        ...submission,
        ...{
          status: 'CLEARANCE',
          clearanceStatus: 'pass',
          type: product.toLocaleLowerCase(),
        },
      },
      NEW_SUBMISSION_PROPS,
    )
    newSubmission.relatedEntities = {
      identifiers: [
        {
          type: 'edge',
          id: edgeSubmissionId,
        },
      ],
    }
    yield put(
      submissionActions.submissionCreate({
        Type: submission.type,
        Origin: edgeSubmissionId,
        ClearanceStatus: newSubmission.clearanceStatus,
      }),
    )
    yield put(submissionActions.clearSubmission())
    yield put(
      submissionActions.changeSubmission(newSubmission, SUBMISSION_FIELDS_DISABLED),
    )
    yield put(submissionActions.changeSubmissionStatus(SUBMISSION_STATUS.EDIT))
    history.push(route)
  } catch (err) {
    yield toastify.error(ToastMessages.failPreClearedSubmission)
  }
}

export function* updateSubmission({
  type,
  payload: { id, submission, user, refetchSubmissions },
}) {
  try {
    const response = yield call(submissionsApi.submissionsPut, id, submission)

    if (response.status !== 200) {
      throw new Error('Operation unsuccessful')
    }
    if (!!submission.workflowStatus) {
      yield put(
        submissionActions.updateWorkflowStatusChange({
          id,
          workflowStatus: submission.workflowStatus,
        }),
      )
    }
    yield put(submissionActions.refetchSubmissions(refetchSubmissions))
  } catch (err) {
    console.log({ err })
  }
}

export function* updateSubmissionManualQuoteStatus({
  type,
  payload: { id, dataForUpdate, user, refetchSubmissions, onSuccess },
}) {
  try {
    yield call(updateSubmission, {
      type: SUBMISSION_UPDATE,
      payload: { id, submission: dataForUpdate, user, refetchSubmissions },
    })
    yield put(
      submissionActions.updateManualQuoteStatusDataForId(
        id,
        dataForUpdate.manualQuoteStatus,
        dataForUpdate.primaryPolicyNumber
      )
    );
    if (typeof onSuccess === 'function') {
      onSuccess();
    }
  } catch (err) {
    console.log(err.message)
  }
}

export function* unlockBind({
  type,
  payload: { id, submission, user, refetchSubmissions },
}) {
  try {
    const response = yield call(submissionsApi.submissionsUnbindPut, id, submission)
    if (response.status !== 200) {
      throw new Error('Operation unsuccessful')
    }
    yield put(
      submissionActions.updateBindStatusChange({
        id,
        isBinded: submission.isBinded,
        isBinderSaved: false,
      }),
    )
    yield put(submissionActions.refetchSubmissions(refetchSubmissions))
  } catch (err) {
    console.log({ err })
  }
}

export function* lockBind({ type, payload: { id, isBinded, isBinderSaved } }) {
  try {
    yield put(submissionActions.updateBindStatusChange({ id, isBinded, isBinderSaved }))
  } catch (err) {
    console.log({ err })
  }
}

export function* refetchSubmissions({ type, payload: { refetchSubmissions } }) {
  try {
    yield call(refetchSubmissions)
  } catch (err) {
    console.log({ err })
  }
}
export function* downloadQuoteSubmission({ type, value: { user, submissionID, flag } }) {
  try {
    if (!submissionID) {
      yield put(submissionActions.getPDFArray())
      return
    }
    const { data } = yield call(
      submissionsApi.downloadQuoteSubmission,
      user,
      submissionID,
      flag,
    )
    data.split(',').forEach((file) => {
      const fileArray = file.split('_')
      if (flag) {
        saveByteArray(base64ToArrayBuffer(fileArray[0]), fileArray[1])
      } else {
        return fileArray
      }
    })
    yield put(submissionActions.getPDFArray(data))
  } catch (err) {
    // This is common error message
    yield put(submissionActions.getPDFArray(undefined, 'failed'))
    if (flag) {
      yield toastify.error(ToastMessages.failPreClearedSubmission)
    }
  }
}

export function* downloadQuoteSpecimenSubmission({
  type,
  value: { user, submissionID, sessionFlag, isDeductibleSpecimen, isExcessSpecimen, revisionNumber },
}) {
  try {
    const { data } = yield call(
      submissionsApi.downloadQuoteSpecimenSubmission,
      user,
      submissionID,
      sessionFlag,
      isDeductibleSpecimen,
      isExcessSpecimen,
      revisionNumber,
    )
    data.split(',').forEach((file) => {
      const fileArray = file.split('_')
      saveByteArray(base64ToArrayBuffer(fileArray[0]), fileArray[1])
    })
  } catch (err) {
    // This is common error message
    yield put(submissionActions.getPDFArray(undefined, 'failed'))

    if (err && err.status === 404) {
      yield toastify.warn(ToastMessages.failSpecimenGet)
    } else {
      yield toastify.error(ToastMessages.failPreClearedSubmission)
    }

  }
}

export function* downloadQuoteRevisionSubmission({
  type,
  value: { user, submissionID, revisionNumber, filterByCoverage, flag },
}) {
  try {
    if (!submissionID) {
      yield put(submissionActions.getPDFArray())
      return
    }
    const { data } = yield call(
      submissionsApi.downloadQuoteRevisionSubmission,
      user,
      submissionID,
      revisionNumber,
      filterByCoverage,
      flag,
    )
    data.split(',').forEach((file) => {
      const fileArray = file.split('_')
      if (flag) {
        saveByteArray(base64ToArrayBuffer(fileArray[0]), fileArray[1])
      } else {
        return fileArray
      }
    })
    yield put(submissionActions.getPDFArray(data))
  } catch (err) {
    // This is common error message
    yield put(submissionActions.getPDFArray(undefined, 'failed'))
    if (flag) {
      yield toastify.error(ToastMessages.failPreClearedSubmission)
    } else {
      return toastify.error(ToastMessagesPdf.failPdf)
    }
  }
}

export function* loadArgopi({ payload }) {
  try {
    const data = yield call(submissionsApi.loadArgopi, payload)
    yield put(submissionActions.loadArgopiSuccess(data))
  } catch (err) {
    yield put(submissionActions.loadArgopiFailure(err))
    console.log({ err })
  }
}

export function* updateSubmissionWithEdgeNumber({ payload }) {
  const { id, submission, user, refetchSubmissions, edgeNumber } = payload
  try {
    yield call(updateSubmission, {
      type: SUBMISSION_UPDATE,
      payload: { id, submission, user, refetchSubmissions }
    })
    yield put(submissionActions.updateSubmissionWithEdgeNumberSuccess())
    yield put(
      submissionActions.updateDataFromModalArray(
        id,
        { edgeNumber }
      )
    );
  } catch (e) {
    yield put(submissionActions.updateSubmissionWithEdgeNumberFailure())
  }
}

export function* watchForClearAndChangeSubmissionStatus() {
  yield takeEvery(CLEAR_AND_CHANGE_SUBMISSION, clearAndChangeSubmissionStatus)
}

export function* watchForGetSubmission() {
  yield takeEvery(GET_SUBMISSION, getSubmission)
}

export function* watchForEditSubmission() {
  yield takeEvery(EDIT_SUBMISSION, editSubmission)
}
export function* watchForCreateRelatedSubmission() {
  yield takeEvery(CREATE_RELATED_SUBMISSION, createRelatedSubmission)
}

export function* watchForSetInitialSubmissionState() {
  yield takeEvery(INITIAL_SUBMISSION_STATE, setInitialSubmissionState)
}

export function* watchForSubmissionSubmitForReview() {
  yield takeEvery(SUBMISSION_SUBMIT_FOR_REVIEW, submissionSubmitForReview)
}

export function* watchForChangeSubmissionDialogStatus() {
  yield takeEvery(CHANGE_SUBMISSION_DIALOG_STATUS, changeSubmissionDialogStatus)
}
export function* watchForChangeSubmitSubmissionQuote() {
  yield takeEvery(SUBMIT_SUBMISSION_QUOTE, submitSubmissionQuote)
}
export function* watchForChangeFetchPreClearedSubmission() {
  yield takeEvery(FETCH_PRE_CLEARED_SUBMISSION, createPreClearedSubmission)
}
export function* watchForUpdateSubmission() {
  yield takeEvery(SUBMISSION_UPDATE, updateSubmission)
}
export function* watchForUnlockBind() {
  yield takeEvery(UNLOCK_BIND, unlockBind)
}
export function* watchForlockBind() {
  yield takeEvery(LOCK_BIND, lockBind)
}
export function* watchForRefetchSubmission() {
  yield takeEvery(SUBMISSIONS_REFETCH, refetchSubmissions)
}
export function* watchForChangeDownloadQuoteSubmission() {
  yield takeEvery(DOWNLOAD_SUBMISSION_QUOTE, downloadQuoteSubmission)
}
export function* watchForChangeDownloadQuoteSpecimenSubmission() {
  yield takeEvery(DOWNLOAD_SUBMISSION_QUOTE_SPECIMEN, downloadQuoteSpecimenSubmission)
}
export function* watchForChangeDownloadQuoteRevisionSubmission() {
  yield takeEvery(DOWNLOAD_SUBMISSION_REVISION_QUOTE, downloadQuoteRevisionSubmission)
}
export function* watchForUpdateSubmissionManualQuoteStatus() {
  yield takeEvery(
    SUBMISSION_UPDATE_MANUAL_QUOTE_STATUS,
    updateSubmissionManualQuoteStatus,
  )
}
export function* watchForloadArgopi() {
  yield takeEvery(LOAD_ARGOPI, loadArgopi)
}
export function* watchForUpdateSubmissionWithEdgeNumber() {
  yield takeEvery(
    SUBMISSION_UPDATE_WITH_EDGE_NUMBER,
    updateSubmissionWithEdgeNumber,
  )
}
export default function* root() {
  yield all([
    fork(watchForClearAndChangeSubmissionStatus),
    fork(watchForGetSubmission),
    fork(watchForEditSubmission),
    fork(watchForCreateRelatedSubmission),
    fork(watchForSetInitialSubmissionState),
    fork(watchForSubmissionSubmitForReview),
    fork(watchForChangeSubmissionDialogStatus),
    fork(watchForChangeSubmitSubmissionQuote),
    fork(watchForChangeFetchPreClearedSubmission),
    fork(watchForUpdateSubmission),
    fork(watchForRefetchSubmission),
    fork(watchForChangeDownloadQuoteSubmission),
    fork(watchForUnlockBind),
    fork(watchForChangeDownloadQuoteRevisionSubmission),
    fork(watchForChangeDownloadQuoteSpecimenSubmission),
    fork(watchForlockBind),
    fork(watchForUpdateSubmissionManualQuoteStatus),
    fork(watchForloadArgopi),
    fork(watchForUpdateSubmissionWithEdgeNumber)
  ])
}
